import { vnModule_knockoutJS } from "../../../valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../../valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

import {vn_app_zone_notification} from "../../../valnet_jslib/vnApp/vn_app_zone_notification";
import * as classicEditor from "@ckeditor/ckeditor5-build-classic";
import {UploadStatusHandler} from "../../../../../js/utils/UploadStatusHandler";
import {isImageOptimizationEnabled} from "../../../../../js/utils/BrandHelper";
import {Utilities as ClaidiUtilities} from "../claidai/utilities";
import { imagePicker_template } from "../components/templates/imagePicker_template";
import { validationsList_template } from "../../../valnet_jslib/vnKnockoutJsTemplates/validationsList_template";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;
export class imagePickerHelper {

    public XHRHdl: XMLHttpRequestHandler;
    protected XHRHdlCaller: string;
    protected XHRHdls: XMLHttpRequestHandler[] = [];

    private imagePicker: imagePicker_template;
    private viewModel: any;
    private vnAppZone: any;
    private widgetTemplate: any;
    private callerModule:any;
    protected progressBar: HTMLProgressElement;
    protected uploadProgress: any;
    private textAreaEditor;
    private contentEditor;
    private imageDescriptionEditor;
    private imageCaptionEditor;
    protected isSaveGallery: any;
    private uploadStatus: UploadStatusHandler ;
    protected imageXHRHdl: XMLHttpRequestHandler;
    protected galleryXHRHdl: XMLHttpRequestHandler;
    protected optimizableSections: Array<string>;
    protected validationTemplate: validationsList_template;

    constructor(imagePicker: imagePicker_template, viewModel: any, vnAppZone: any, callerModule:any, optimizableSections: Array<string> = []) {

        imagePicker.setCaller(this);
        this.imagePicker = imagePicker;
        this.viewModel = viewModel;
        this.vnAppZone = vnAppZone;
        this.callerModule = callerModule;
        this.uploadStatus = new UploadStatusHandler();
        this.optimizableSections = optimizableSections;
        this.validationTemplate = callerModule.validationTemplate;
        imagePicker.imageAdd.isOptimizationEnabled = isImageOptimizationEnabled(Number(vnAppZone.app.params.idBrand));
    }

    public setWidgetTemplate(widgetTemplate: any) {

        this.widgetTemplate = widgetTemplate;
        widgetTemplate.setCaller(this);

    }

    public getWidgetTemplate() {
        return this.widgetTemplate;
    }

    public getUrlBase(): string {
        let idBrand = this.vnAppZone.app.params.idBrand;

        return idBrand? '/api/brand/' + idBrand : '/api/';
    }

    public getImageById(idImage) {

        if (this.callerModule && typeof this.callerModule.getImageById === 'function') {
            this.callerModule.getImageById(idImage);
            return;
        }

        if (this.imageXHRHdl) {
            this.imageXHRHdl.cancelAndReset();
        }

        let formReq_url: string = this.getUrlBase() + '/images/get/' + idImage;
        let formReq_params: Array<Array<string>> = [];

        this.imageXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.imageXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.imageXHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
        this.imageXHRHdl.execute();
    }

    public getImageData() {

        if (this.callerModule && typeof this.callerModule.getImageData === 'function') {
            this.callerModule.getImageData();
            return;
        }

        if (this.imageXHRHdl) {
            this.imageXHRHdl.cancelAndReset();
        }

        this.imagePicker.showLoading();

        let formReq_url: string = this.getUrlBase() + '/images/get/';
        let formReq_params: Array<Array<string>> = [];

        //let subViewModel = JSON.parse(ko.toJSON(this.viewModel));

        formReq_params.push(["data", ko.toJSON(this.imagePicker.getViewModelForRequest())]);

        this.imageXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.imageXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.imageXHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
        this.imageXHRHdl.execute();
    }

    protected onGetImageDataReturn(req, obj) {

        if (this.callerModule && typeof this.callerModule.onGetImageDataReturn === 'function') {
            this.callerModule.onGetImageDataReturn(req, obj);
            return;
        }

        return function () {

            obj.callerModule.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateImagePickerForm(responseParsed);
                obj.imagePicker.hideLoading();
                if (obj.imagePicker.getSelectedTab() == 'images' || obj.isSaveImage) {
                    obj.isSaveImage = false;
                }
            })
        }

    }

    protected getGalleryData() {

        if (this.callerModule && typeof this.callerModule.getGalleryData === 'function') {
            this.callerModule.getGalleryData();
            return;
        }

        if( this.galleryXHRHdl ){
            this.galleryXHRHdl.cancelAndReset();
        }
        this.imagePicker.showLoading();


        let idBrand = this.vnAppZone.app.params.idBrand;
        let formReq_url: string = '/api/brand/'+idBrand+'/galleries/get/';
        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(this.imagePicker.getViewModelForRequest())]);

        this.galleryXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.galleryXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;

        this.galleryXHRHdl.onReadyStateFunction = this.onGetGalleryDataReturn;
        this.galleryXHRHdl.execute();
    }

    protected onGetGalleryDataReturn(req, obj){

        if (this.callerModule && typeof this.callerModule.onGetGalleryDataReturn === 'function') {
            this.callerModule.onGetGalleryDataReturn(req, obj);
            return;
        }

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateImagePickerForm(responseParsed);
                if(obj.imagePicker.getSelectedTab() == 'galleries' || obj.isSaveGallery) {
                    obj.imagePicker.hideLoading();
                    obj.isSaveGallery = false;
                }
            })
        }
    }

    protected insertGallery(gallery, target, extra_option) {

        if (this.callerModule && typeof this.callerModule.insertGallery === 'function') {
            this.callerModule.insertGallery(gallery, target, extra_option);
            return;
        }
    }

    protected saveGallery(gallery, insert, param) {

        if (this.callerModule && typeof this.callerModule.getGalleryData === 'function') {
            this.callerModule.saveGallery(gallery, insert, param);
            return;
        }

        this.isSaveGallery = true;
        let idBrand = this.vnAppZone.app.params.idBrand;
        let formReq_url: string = '/api/brand/'+idBrand+'/galleries/save/';
        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(["data", ko.toJSON(gallery)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);
                    obj.imagePicker.onGallerySaveReturn(responseParsed.gallery, insert, param);
                    obj.getGalleryData();
                })

            }
        });
        XHRHdl.execute();
    }


    protected updateImagePickerForm(responseParsed) {

        if (this.callerModule && typeof this.callerModule.updateImagePickerForm === 'function') {
            this.callerModule.updateImagePickerForm(responseParsed);
            return;
        }

        let selectedImages = this.imagePicker.getSelectedImages();

        if (responseParsed.paginatedImages && responseParsed.paginatedImages.data) {
            for (let image of responseParsed.paginatedImages.data) {
                image.selected = false;
                let imageSelected = selectedImages.find(i => i.id == image.id);
                if (imageSelected) {
                    image.selected = true;
                }
                image.fileSize = this.bytesToSize(image.fileSize);
            }
            this.imagePicker.setImagesPagination(responseParsed.paginatedImages);
            this.imagePicker.setImageResults(responseParsed.paginatedImages.data);

            if (responseParsed.imagesInContent) {
                for (let image of responseParsed.imagesInContent) {
                    image.selected = false;
                    let imageSelected = selectedImages.find(i => i.id == image.id);
                    if (imageSelected) {
                        image.selected = true;
                    }
                    image.fileSize = this.bytesToSize(image.fileSize);
                }
                this.imagePicker.setImagesInContent(responseParsed.imagesInContent);
            }

            if (responseParsed.imagesInContent) {
                for (let image of responseParsed.imagesInContent) {
                    image.selected = false;
                    let imageSelected = selectedImages.find(i => i.id == image.id);
                    if (imageSelected) {
                        image.selected = true;
                    }
                    image.fileSize = this.bytesToSize(image.fileSize);
                }
                this.imagePicker.setImagesInContent(responseParsed.imagesInContent);
            }

            let selectedGallery = this.imagePicker.getSelectedGallery();

            if( responseParsed.paginatedGalleries && responseParsed.paginatedGalleries.data){
                for(let gallery of responseParsed.paginatedGalleries.data){
                    gallery.selected = false;
                    if (selectedGallery != null) {
                        if (selectedGallery.id == gallery.id) {
                            gallery.selected = true;
                        }
                    }
                }
                this.imagePicker.setGalleryPagination(responseParsed.paginatedGalleries);
                this.imagePicker.setGalleryResults(responseParsed.paginatedGalleries.data);
            }

            if (responseParsed.ratios) {
                this.imagePicker.setRatios(responseParsed.ratios);
            }

            if (responseParsed.orientations) {
                this.imagePicker.setOrientations(responseParsed.orientations);
            }

            if (responseParsed.uploadSources) {
                this.imagePicker.setUploadSources(responseParsed.uploadSources, responseParsed.selectedUploadSource);
            }

            if (responseParsed.idBrand) {
                this.imagePicker.setIdBrand(responseParsed.idBrand);
            }

            if (responseParsed.totalCount) {
                this.imagePicker.setTotalCount(responseParsed.totalCount);
            }

        }
    }
    protected filterSimpleCancel() {
        if (this.imageXHRHdl) {
            this.imageXHRHdl.cancelAndReset();
        }
    }

    // @TODO move this to helper methods at bottom
    protected bytesToSize(bytes) {
        var sizes = ['KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return 'n/a';
        var i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
        if (i == 0) return bytes + ' ' + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
    }

    public insertImage(image, target, extra_mode = null) {

        if (this.callerModule && typeof this.callerModule.insertImage === 'function') {
            this.callerModule.insertImage(image, target, extra_mode);
            return;
        }

        if (typeof this.widgetTemplate !== 'undefined' && this.widgetTemplate !== null && typeof this.widgetTemplate.setImage === 'function') {
            this.widgetTemplate.setImage(image);
            this.widgetTemplate = null;
        }

    }

    protected insertImages(images, target, extra_option) {

        if (this.callerModule && typeof this.callerModule.insertImages === 'function') {
            this.callerModule.insertImages(images, target, extra_option);
            return;
        }
    }

    public setImageDescription(description) {

        /*if (this.callerModule && typeof this.callerModule.setImageDescription === 'function') {
            this.callerModule.setImageDescription(description);
            return;
        }*/
        if(!this.imageDescriptionEditor){
            this.initializeCkEditors();
        }

        this.imageDescriptionEditor.setData(description, function () {
            this.resetUndo();
        });
    }

    public setImageCaption(caption) {

       /* if (this.callerModule && typeof this.callerModule.setImageCaption === 'function') {
            this.callerModule.setImageCaption(caption);
            return;
        }*/

        if(!this.imageCaptionEditor){
            this.initializeCkEditors();
        }

        this.imageCaptionEditor.setData(caption, function () {
            this.resetUndo();
        });
    }

    public getImageDescription(description) {

        /*if (this.callerModule && typeof this.callerModule.getImageDescription === 'function') {
            return this.callerModule.getImageDescription(description);
        }*/

        return this.imageDescriptionEditor.getData();
    }


    public getImageCaption(description) {

         /*if (this.callerModule && typeof this.callerModule.getImageCaption === 'function') {
            return this.callerModule.getImageCaption(description);
        }*/

        return this.imageCaptionEditor.getData();
    }

    protected initializeCkEditors() {

        for(let name in CKEDITOR.instances)
        {
            if (name == "image_description" || name == "image_caption") {
                CKEDITOR.instances[name].destroy(true);
            }
        }

        if (!CKEDITOR.stylesSet.registered.my_styles) {
            CKEDITOR.stylesSet.add('my_styles', [
                // Block-level styles.
                {name: 'Heading 1', element: 'h1'},
                {name: 'Heading 2', element: 'h2'},
                {name: 'Heading 3', element: 'h3'},
                {name: 'Preformatted', element: 'pre'},
                // Inline styles.
                {name: 'Related: One link', element: 'span', attributes: {'class': 'related-single'}},
                {name: 'Next - One link', element: 'span', attributes: {'class': 'next-single'}},
                {name: 'Affiliate - One link', element: 'span', attributes: {'class': 'affiliate-single'}},
                {name: 'Spoiler Alert', element: 'span', attributes: {'class': 'article-alert'}},
                {name: 'Tip', element: 'div', attributes: {'class': 'emaki-custom tip'}},
                {name: 'Warning', element: 'div', attributes: {'class': 'emaki-custom warning'}},
                {name: 'Note', element: 'div', attributes: {'class': 'emaki-custom note'}},
                {name: 'Expandable', element: 'div', attributes: {'class': 'emaki-custom expandable'}},
                {name: 'Pullquote', element: 'div', attributes: {'class': 'emaki-custom pullquote'}},
                {name: 'Promoted', element: 'div', attributes: {'class': 'emaki-custom promoted'}},

            ]);
        }
        //                {name: '', element: 'span', attributes: {'data-field': 'rating'}},


        CKEDITOR.on('dialogDefinition', function (ev) {
            var dialogName = ev.data.name;
            var dialogDefinition = ev.data.definition;

            //Remove background color and border color in dialog cells properties
            if(dialogName == "cellProperties"){
                // "bgColor"
                // "borderColor"
                const cellProps = dialogDefinition.getContents('info');
                cellProps.remove("borderColor")
                cellProps.remove("bgColor")
            }

            //remove features from table dialog
            if (dialogName == 'table') {

                // Get the advanced tab reference
                var infoTab2 = dialogDefinition.getContents('advanced');

                //Set the default
                // Remove the 'Advanced' tab completely
                dialogDefinition.removeContents('advanced');

                // Get the properties tab reference
                var infoTab = dialogDefinition.getContents('info');

                // Remove unnecessary bits from this tab
                /// infoTab.remove('txtBorder');
                infoTab.remove('cmbAlign');
                infoTab.remove('txtWidth');
                infoTab.remove('txtHeight');
                // infoTab.remove('txtCellSpace');
                //infoTab.remove('txtCellPad');
                infoTab.remove('txtCaption');
                infoTab.remove('txtSummary');
            }


            if (dialogName == 'link') {

                /* Getting the contents of the Target tab */

                var targetTab = dialogDefinition.getContents('target');
                var informationTab = dialogDefinition.getContents('info');
                var advancedTab = dialogDefinition.getContents('advanced');

                //remove the browse server button
                informationTab.remove('browse')

                //moving the target dropdown to the main tab
                var targetField = targetTab.get('linkTargetType');

                targetTab.remove('linkTargetType');
                informationTab.add(targetField);

            }
        });

        let allEditors = [];

        //Directory item CK editor


        // Image Description Editor
        this.initCkEditor('image_description');
        this.imageDescriptionEditor = CKEDITOR.instances.image_description;
        allEditors.push(this.imageDescriptionEditor);

        // Image Caption Editor
        this.initCkEditor('image_caption');
        this.imageCaptionEditor = CKEDITOR.instances.image_caption;
        allEditors.push(this.imageCaptionEditor);


    }

    protected initCkEditor(idElement) {

        let height, toolbarMA;
        let disallowedContent = 'p';
        //contextmenu,tabletools,tableselection
        let removePlugins = 'elementspath,liststyle,image,forms';
        if ( idElement == "image_description" || idElement == "image_caption" || idElement == "gallery_description")
        {
            disallowedContent += ',ul,ol,li';
            removePlugins+= ',list';
            toolbarMA = [[ 'Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-',  'SpecialChar', 'Bold', 'Italic', 'Strike', '-','LinkBtn']];
            height = '125px';
        }
        else
        {
            height = '500px';
            //height = '1500px';
            toolbarMA = [['Source', '-', 'Cut', 'Copy', 'Paste', '-', 'Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-', 'Table', 'HorizontalRule', 'SpecialChar', 'ImgBtn', 'VideoBtn', 'TagBtn', 'EmbedBtn', 'UpdateBtn','KeyPointsBtn','Styles'], ['Bold', 'Italic', 'Strike', 'NumberedList', 'BulletedList', '-', 'Blockquote', 'LinkBtn']];
        }

        CKEDITOR.replace(idElement, {
            height: height,
            toolbar: 'MA',
            fillEmptyBlocks: false,
            extraAllowedContent: 'span(*)[!data-field];img(*){*}[*];div(*){*}[*];pre(*){*}[*];code(*){*}[*];a[rel];a[target];a[href];a[title];a(*);*[id];blockquote(*){*}[*];iframe(*){*}[*];p(*){*}[*];script(*){*}[*];section(*){*}[*];button(*){*}[*];ul(*){*}[*];li(*){*}[*];h2(*){*}[*];h3(*){*}[*];dl(*){*}[*];dt(*){*}[*];dd(*){*}[*];video(*){*}[*];audio(*){*}[*];source(*){*}[*]',
            disallowedContent: disallowedContent,
            removePlugins: removePlugins,
            stylesSet: 'my_styles',
            format_tags: "p;h1;h2;h3",
            format_p: {
                element: 'p'
            },
            toolbar_MA : toolbarMA
        });

        //'JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock'
        //'Outdent','Indent'



        //CKEDITOR.config.toolbar_MA = toolbarMA;

        CKEDITOR.config.enterMode = CKEDITOR.ENTER_BR;

        CKEDITOR.config.contentsCss = [CKEDITOR.getUrl('contents.css'), '/css/cke_style.css?v=7.5'];

        //CKEDITOR.config.disallowedContent = 'p';

        CKEDITOR.config.skin = "n1theme";
        //CKEDITOR.config.skin ="kama";
        //CKEDITOR.config.skin ="moono";
        //CKEDITOR.config.skin ="moono-lisa";
        CKEDITOR.config.extraPlugins = "wordcount,notification,openlink";
        //CKEDITOR.config.extraPlugins ="justify";
        //CKEDITOR.config.extraPlugins ="colorbutton";

        CKEDITOR.config.forcePasteAsPlainText = false;
        //contentEditor = CKEDITOR.instances.article_content;

        CKEDITOR.config.wordcount = {
            // Whether or not you want to show the Paragraphs Count
            showParagraphs: false,

            // Whether or not you want to show the Word Count
            showWordCount: true,

            // Whether or not you want to show the Char Count
            showCharCount: true
        }
    }

    public showImagePicker(mode, target, selectedImages = [], widget = null) {

        if (this.callerModule && typeof this.callerModule.showImagePicker === 'function') {
            this.callerModule.showImagePicker(mode,target,selectedImages);
            return;
        }

        if(widget !== null){
            this.setWidgetTemplate(widget);
        } else if (this.getWidgetTemplate() == null) {
            this.widgetTemplate = null;
            //console.log("Widget template is null");
            //return; // something is wrong we should know what image widget is at this point
        }

        this.imagePicker.setIsImageOptimizable(this.isOptimizable(target));
        this.imagePicker.setMode(mode);
        this.imagePicker.setTarget(target);

        if (Array.isArray(selectedImages) && selectedImages.length > 0) {
            this.imagePicker.setSelectedImages(selectedImages);
        }else{
            this.imagePicker.setSelectedImages([]);
        }

        this.getImageData();

        this.imagePicker.show();
    }

    public addImage(target, viewMode, widget = null){

        if (this.callerModule && typeof this.callerModule.addImage === 'function') {
            this.callerModule.addImage(target, viewMode);
            return;
        }

        if(widget !== null){
            this.setWidgetTemplate(widget);
        }

        this.showImagePicker(viewMode, target);
    }

    public addImageGroup(target, viewMode, selectedImages, widget = null){

        if (this.callerModule && typeof this.callerModule.addImageGroup === 'function') {
            this.callerModule.addImageGroup(target, viewMode, selectedImages);
            return;
        }

        if(widget !== null){
            this.setWidgetTemplate(widget);
        }

        this.showImagePicker(viewMode, target, selectedImages);
    }

    public editImage(target, viewMode, widget = null){

        this.initializeCkEditors();

        /*if (this.callerModule && typeof this.callerModule.editImage === 'function') {
            this.callerModule.editImage(target, viewMode);
            return;
        }*/

        if(widget !== null){
            this.setWidgetTemplate(widget);
        }

        this.showImagePicker(viewMode, target);
        let image = this.widgetTemplate.getImage()

        this.imagePicker.editImage(image, viewMode);

    }

    public closeImage(target) {

        if (this.callerModule && typeof this.callerModule.closeImage === 'function') {
            this.callerModule.closeImage(target);
            return;
        }

        let element = document.getElementById(target);
        element.classList.remove("is-viewing");

    }

    public removeImage(target, widget = null){

        if (this.callerModule && typeof this.callerModule.removeImage === 'function') {
            this.callerModule.removeImage(target);
            return;
        }

        if(widget !== null){
            this.setWidgetTemplate(widget);
        }

        this.widgetTemplate.clearImage();

    }

    public removeImageGroup(target, widget = null){

        if (this.callerModule && typeof this.callerModule.removeImageGroup === 'function') {
            this.callerModule.removeImageGroup(target);
            return;
        }

        if(widget !== null){
            this.setWidgetTemplate(widget);
        }

        this.imagePicker.deselectAllImages();

    }

    protected async handleFiles(files, event?, options = {}) {

        if (Object.keys(options).length > 0) {

            try {
                files = await this.upscaleFiles(files, options);
                sessionStorage.removeItem("claidApiErrorMessage");
            } catch (error) {

                this.disableLoading("is-generating");
                sessionStorage.setItem("claidApiErrorMessage", error.CustomMessage);
            }
        }

        if (this.callerModule && typeof this.callerModule.handleFiles === 'function') {

            this.callerModule.handleFiles(files);
            return;
        }

        this.uploadImages(files);
    }

    public async checkImagesSizesInformation(files, event?) {
        const imagesWithHeigthLess1080p = await this.checkImagesWithHeightLessThan1080p(files)
        if(imagesWithHeigthLess1080p.length > 0){

            const strInvalidImages = `
            <ul class="scrolling-warning-list">
                    ${imagesWithHeigthLess1080p.map(item => `<li style="margin: 5px">${item.name}</li>`).join("")}
                </ul>`;

            const confirmDialog = this.imagePicker.imageAdd.confirmDialog;
            confirmDialog.setDialogMessage(
                `<p style="margin: 5px">The resolution of the listed images is below the standard 1080p (height is less than 1080 pixels).</p>` +
                `<p style="margin: 5px">With 1080p being the most common screen resolution, note that these images will not be optimal for the
                    standard use cases (featured image, in-content images, etc.).</p>` +

                `<p style="margin: 5px">Do you want to proceed with the upload?</p>` +
                `${strInvalidImages}`

            )

            const userConfirmation = await confirmDialog.showConfirmDialog(); //This will wait for the user input during execution

            if(!userConfirmation){
                if(event) event.target.value = '';
                return false;
            }
        }

        return true;
    }
    protected uploadImages(files) {

        if (this.callerModule && typeof this.callerModule.handleFiles === 'function') {
            this.callerModule.handleFiles(files);
            return;
        }


        console.log('trial  - ' + this.uploadStatus.currentTrial);

        let parent = this;
        let idBrand = this.vnAppZone.app.params.idBrand;

        let formReq_url: string = this.getUrlBase() + '/images/upload/';

        var formData = new FormData();

        this.initializeProgress(files.length);

        if (files.length > 1) {

            this.imagePicker.hideImageAdd();
            this.imagePicker.showLoading();
        }

        this.imagePicker.clearFilters();

        // upload status vars.
        this.uploadStatus.nextTrial();

        for (let i = 0; i < files.length; i++) {

            formData.append("file_" + i, files[i]);

        }
        if (idBrand) {
            formData.append("idBrand", idBrand);
        }

        let request = [];
        var xhttp = new XMLHttpRequest();
        request["request"] = xhttp;

        // Set POST method and ajax file path
        xhttp.open("POST", formReq_url, true);

        let onReadyStateFunction = (function (req, obj) {

            return function () {

                if (req.request.readyState == 4) {

                    if (req.request.status == 200) {

                        // reset the upload status when successful operation is complete.
                        obj.uploadStatus.reset();
                        let fileElement: any = document.getElementById("fileElem");
                        fileElement.value = '';
                        let response = JSON.parse(req.request.response);

                        obj.updateProgress(response.images.length, 100) // <- Add this

                        if (response.images.length == 1 && response.errors.length == 0 ) {

                            obj.imagePicker.editImage(response.images[0]);
                            obj.imagePicker.hideLoading();
                        }

                        if ((response.images.length == 1 && response.errors.length == 1)  || response.images.length > 1) {

                            obj.imagePicker.hideImageAdd();
                            obj.imagePicker.handleBulkImages(response.images);
                            obj.imagePicker.hideLoading();

                            if(response.errors.length == 1) {

                                obj.imagePicker.imagesBulkEdit.validationsList.setMessages(response.errors)
                            }
                        }
                        obj.resetProgress();
                        obj.validationTemplate.clearMessages();

                    }else if (req.request.status == 400) {

                        let responseParsed = JSON.parse(req.request.response)
                        obj.imagePicker.imageAdd.validationsList.setMessages(responseParsed.validations);
                        obj.imagePicker.hideLoading();
                        window.scrollTo(0, 0);

                    } else {
                        obj.uploadStatus.isInProgress = false;
                        obj.imagePicker.showUploadError();
                    }
                }

            }
        });

        // call on request changes state
        xhttp.onreadystatechange = onReadyStateFunction(request, this);

        let firstTime = new Date().getTime();
        xhttp.upload.addEventListener("progress", function (e) {

            parent.uploadStatus.progress = e.loaded;
            let progressTime = new Date().getTime();
            let diff =  progressTime - firstTime;
            firstTime = progressTime;
            console.log('Upload Image progress: ', e.loaded, e.total, parent.uploadStatus.progress, diff);
        });

        xhttp.upload.addEventListener('loadend', (e) => {

            if (!parent.uploadStatus.isInProgress && parent.uploadStatus.trialsReached()) {
                xhttp.abort();
                parent.imagePicker.showPickerUploadError();
                parent.imagePicker.hideLoading();
            }
            console.log('Upload Image Loadend: ', parent.uploadStatus.progress, e.loaded, e.total);
        });

        xhttp.upload.addEventListener('loadstart', (e) => {

            console.log('timeout started');
            setTimeout(() => {

                // check after one second if the progress is blocked then trigger another try.
                if (!parent.uploadStatus.isInProgress && !parent.uploadStatus.trialsReached()) {
                    xhttp.abort();
                    parent.uploadImages(files);
                }
            }, 1000);

        });

        // Send request with data
        xhttp.send(formData);
    }

    public reset(){

        if (this.callerModule && typeof this.callerModule.reset === 'function') {
            this.callerModule.reset();
            return;
        }

        this.uploadStatus.reset();
        this.imagePicker.hidePickerUploadError();
    }

    protected initializeProgress(numFiles) {

        if (this.callerModule && typeof this.callerModule.initializeProgress === 'function') {
            this.callerModule.initializeProgress(numFiles);
            return;
        }

        this.progressBar = <HTMLProgressElement>document.getElementById('progress-bar');
        this.progressBar.value = 0
        this.uploadProgress = [];

        for (let i = numFiles; i > 0; i--) {
            this.uploadProgress.push(0)
        }
    }

    protected resetProgress() {

        if (this.callerModule && typeof this.callerModule.resetProgress === 'function') {
            this.callerModule.resetProgress();
            return;
        }

        this.progressBar = <HTMLProgressElement>document.getElementById('progress-bar');
        this.progressBar.value = 0
    }

    protected updateProgress(fileNumber, percent): void {

        if (this.callerModule && typeof this.callerModule.updateProgress === 'function') {
            this.callerModule.updateProgress(fileNumber, percent);
            return;
        }

        this.progressBar.value = percent;
    }

    protected deleteImage(image){

        if (this.callerModule && typeof this.callerModule.deleteImage === 'function') {
            this.callerModule.deleteImage(image);
            return;
        }

        let formReq_url: string = this.getUrlBase() + '/images/delete/' + image.id;
        let formReq_params: Array<Array<string>> = [];

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.callerModule.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getImageData();
                })

            }
        });
        XHRHdl.execute();
    }

    protected saveImages(images, insert, param, insertType='image', widget = null) {

        if (this.callerModule && typeof this.callerModule.saveImages === 'function') {
            this.callerModule.saveImages(images, insert, param, insertType, widget);
            return;
        }

        let formReq_url: string = this.getUrlBase() + '/images/save/';
        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(images)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.callerModule.manageResponse(req, obj, function () {

                    let response = JSON.parse(req.request.response);

                    obj.widgetTemplate.setImage(response.images[0].image);
                    obj.widgetTemplate = null;
                    obj.imagePicker.onImageSaveReturn(response.images, insert, param, insertType);
                    obj.getImageData();
                })

            }
        });
        XHRHdl.execute();
    }

    public viewImage(target){
        let element = document.getElementById(target);
        element.classList.add("is-viewing");

    }

    protected filterSimpleOnChange(idElement) {
        //*** Expand on this function */
        switch (idElement) {
            case "filterTagImagePickerEdit":
                this.imagePicker.imageEdit.updateSelectedTags();
                break;
            case "filterTagImagePickerBulkEdit":
                this.imagePicker.imagesBulkEdit.updateSelectedTags();
                break;

            default:
                this.getImageData();

                if (this.callerModule && typeof this.callerModule.getGalleryData === 'function') {
                    this.callerModule.getGalleryData();
                    return;
                }
        }
    }

    public getTagsSuggestion(keyword, idSourceElement){
        this.XHRHdlCaller = "getSuggestions_" + idSourceElement;
        // add more cases if needed.
        switch (idSourceElement) {
            case "filterTagImagePickerEdit":
            case "tagFilter":
                this.getTagsSuggestionOnInput(keyword, 5, null, true, false, false);
                break;
            case "filterTagImagePickerBulkEdit":
                this.getTagsSuggestionOnInput(keyword, 5, null, true, false, false);
                break;


            default:
                // pass the rest off to the caller
                if (this.callerModule) {
                    this.callerModule.getTagsSuggestion(keyword, idSourceElement);
                }
                break;
        }
    }

    protected getTagsSuggestionOnInput(keyword, limit, tagType, getSelectable, getNonSelectable, imageAndSpecSelectable, specFields = false) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {filter: {keyword: keyword, limit: limit, idTagType: tagType ? tagType.id : null, getSelectable:getSelectable, getNonSelectable:getNonSelectable, imageAndSpecSelectable: imageAndSpecSelectable, specFields: specFields} };

        let usrReq_url: string = '/api/brand/' + this.callerModule.getVnAppZone().app.params.idBrand + "/search/tag/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.callerModule.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.tags)
                {
                    switch(obj.XHRHdlCaller) {
                        case "getSuggestions_filterTagImagePickerEdit":
                            obj.imagePicker.imageEdit.filterTag.getTemplateViewModel().tags(responseParsed.data.tags);
                            break;
                        case "getSuggestions_filterTagImagePickerBulkEdit":
                            obj.imagePicker.imagesBulkEdit.filterTag.getTemplateViewModel().tags(responseParsed.data.tags);
                            break;
                        case "getSuggestions_tagFilter":
                            obj.imagePicker.tagFilter.getTemplateViewModel().tags(responseParsed.data.tags);
                            break;
                            // no default
                    }
                }
            });
        }
    }

    protected onClickInsertImageGroupTag(images, target, markup) {


        if (this.callerModule && typeof this.callerModule.onClickInsertImageGroupTag === 'function') {
            this.callerModule.onClickInsertImageGroupTag(images, target, markup);
            return;
        }

        // @TODO revisit
        this.imagePicker.setSelectedImages(images);
        this.imagePicker.setSelectedImagesMarkup(markup);
        this.widgetTemplate.setSelectedImages(images);
        this.widgetTemplate.setSelectedImagesMarkup(markup);

    }

    public filterDropdownOnChange(idElement) {

        if (this.callerModule && typeof this.callerModule.filterDropdownOnChange === 'function') {
            this.callerModule.filterDropdownOnChange(idElement);
            return;
        }

        switch (idElement) {
            default:
                this.getImageData();
                break;
        }
    }

    public isOptimizable(target): boolean {

        return (this.optimizableSections.indexOf(target) != -1);
    }

    public setIsImageOptimized(isImageOptimized) {
        if (this.callerModule && typeof this.callerModule.setIsImageOptimized === "function") {
            this.callerModule.setIsImageOptimized(false);
        }
    }

    public async getUploadedImagesInfos(files: FileList) {
        const imageDimensions = await Promise.all(Array.from(files).map(this.getImageDimensions));
        return imageDimensions.filter(Boolean);
    }

    public getImageDimensions(file: File): Promise<null | {name : string, width: number, height: number}> {
        return new Promise((resolve) => {
            if (!file.type.startsWith('image/')) {
                resolve(null);
                return;
            }

            const img = new Image();
            img.onload = () => resolve({name: file.name, width: img.width, height: img.height});
            img.src = URL.createObjectURL(file);
        });
    }

    /**
     * Check images with height less than 1080p.
     *
     * @param {FileList} files - An array-like object containing image files.
     * @returns {Promise<Array<{name: string, width: number, height: number}>>} - An array of image info objects where height is less than 1080.
     */
    public async checkImagesWithHeightLessThan1080p(files: FileList) : Promise<{name: string, width: number, height: number}[]> {
        const imagesInfos = await this.getUploadedImagesInfos(files)
        return imagesInfos.filter(i => i.height < 1080)
    }

    public async upscaleFiles(files: File[], settings = {}): Promise<File[]> {

        this.enableLoading("is-generating");
        const operations = {
        };

        if (settings['isAiEnhanced']) {
            operations['restorations'] = {
                decompress: "auto",
                upscale: "smart_enhance"
            };
        }

        if (settings['isHdrAdjusted']) {
            operations['adjustments'] = {
                hdr: 100
            };
        }

        const optimizedFiles: File[] = await ClaidiUtilities.createUpscaledFiles(files, {operations: operations});

        this.disableLoading("is-generating");
        return optimizedFiles;
    }

    public enableLoading(cssClass = "loading") {
        let currentComponent = document.getElementById('imageAdd');
        let currentElement = currentComponent.querySelector('#add-image-upload-zone');
        currentElement.classList.add(cssClass);
    }

    public disableLoading(cssClass = "loading"){
        let currentComponent = document.getElementById('imageAdd');
        let currentElement = currentComponent.querySelector('#add-image-upload-zone');
        currentElement.classList.remove(cssClass);
    }


    protected async validateImages(files) {

        this.enableLoading();

        let formReq_url: string =  `/api/images/validate/`;

        var formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append("file_" + i, files[i]);
        }

        let requestBody = {
            method: 'POST',
            body: formData,
        };

        const response: Response = await fetch(formReq_url, requestBody);
        const data = await response.json();
        this.disableLoading();

        return data;
    }

}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper.ts